export default class Stater{
    init = false
    loading = false
    loadingUpdate = false
    error = false
    errorMessage = null
    success = false
    progress = 0
    modal = false
    data = null
    data1 = null
    data2 = null
    data3 = null

    constructor(data=null, data1=null, data2=null, data3=null) {
      this.stateClear();
      this.init = true;
      this.modal = false;
      this.data = data;
      this.data1 = data1;
      this.data2 = data2;
      this.data3 = data3;
    }

    stateClear(){
      this.init = false;
      this.loading = false;
      this.loadingUpdate = false;
      this.error = false;
      this.success = false;
    }
    stateInit(){
      this.stateClear();
      this.init = true
    }
    stateLoading(){
      this.stateClear();
      this.loading = true
    }
    stateLoadingUpdate(){
      this.stateClear();
      this.loadingUpdate = true
    }
    stateError(errorMessage){this.stateClear(); this.error = true; this.errorMessage = errorMessage}
    stateSuccess(){
      this.stateClear();
      this.success = true
    }

    modalOpen(data=null, data1=null, data2=null, data3=null){
      this.modal = true;
      this.data = data;
      this.data1 = data1;
      this.data2 = data2;
      this.data3 = data3;
    }
    modalClose(data=null, data1=null, data2=null, data3=null){
      this.modal = false;
      setTimeout(()=>{
          this.data = data;
          this.data1 = data1;
          this.data2 = data2;
          this.data3 = data3;
      }, 250);
    }

    setRequestBuilderState(v, dataCanEmpty=true, dataAppend=false){
      if(dataAppend){
        let items = this.data.items;
        v.items.forEach(v1=>{
          if(items.filter(v2=>v2.id===v1.id).length===0)
            items.push(v1);
        })
        this.data = {
          count:v.count,
          items:items,
          collect:v.collect
        };
      } else {
        if(dataCanEmpty){
          this.data = {
            count:v.count,
            items:v.items,
            collect:v.collect
          };
        } else {
          if(v.count>0){
            this.data = {
              count:v.count,
              items:v.items,
              collect:v.collect
            };
          }
        }
      }

      this.loading = v.loading;
      this.success = v.success;
      this.error = v.error;
      this.errorMessage = v.errorMessage;
    }

}
